// Utilidad para obtener la hora local en una zona horaria y comparar con la hora de corte
export function isAfterCutoff(timezone, cutoffHour, cutoffMinute) {
  // Obtener la hora local en la zona horaria
  const now = new Date();
  // Convertir a string ISO y luego a la zona horaria deseada
  // Usar Intl.DateTimeFormat para obtener la hora local
  const options = { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: timezone };
  const [hourStr, minuteStr] = new Intl.DateTimeFormat('en-US', options)
    .formatToParts(now)
    .filter(p => p.type === 'hour' || p.type === 'minute')
    .map(p => p.value);
  const hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);
  if (hour > cutoffHour) return true;
  if (hour === cutoffHour && minute >= cutoffMinute) return true;
  return false;
}
